import styled from 'styled-components';

import { breakpoints } from '@notino/react-styleguide-v20';

import { PAGE_MAX_WIDTH } from '@styles/constants';

interface IWrapperProps {
  backgroundImageUrl: string;
}

export const Wrapper = styled.div<IWrapperProps>`
  max-width: ${PAGE_MAX_WIDTH}rem;
  margin-left: auto;
  margin-right: auto;
  padding: 4rem 1.25rem 0 1.25rem;
  font-size: 0.875rem;
  height: 100%;
  box-sizing: border-box;

  @media (min-width: ${breakpoints.sm}) {
    padding: 5rem 5rem 0 5rem;
  }

  @media (min-width: ${breakpoints.md}) {
    background: url(${({ backgroundImageUrl }) => backgroundImageUrl}) no-repeat right bottom;
    background-size: auto 310px;
  }
`;

export const Title = styled.div`
  font-size: 1.125rem;
  font-weight: 300;

  @media (min-width: ${breakpoints.sm}) {
    font-size: 2rem;
  }
`;

export const Description = styled.div`
  margin-top: 1rem;
`;

export const Links = styled.div`
  margin-top: 1rem;
`;

export const ErrorCode = styled.p`
  margin-top: 1rem;
  font-weight: bold;
`;
